import FormErrorMessage from '@/common/components/FormErrorMessage.tsx'
import { Input } from '@/app/common/components/input/Input'
import Label from '@/common/components/Label.tsx'
import { Control, Controller, FieldErrors, UseFormWatch } from 'react-hook-form'
import { YesOrNoOptions } from '../../constants/constants'
import { STANDARDIZED_TESTS } from '../../questions.constant'
import CheckboxQuestion from '../form_elements/CheckboxQuestion'
import RadioButtonQuestion from '../form_elements/RadioButtonQuestion'
import { SchoolFormValues } from '@/pages/providers/components/SchoolForm/schoolForm.schema.ts'
import FormSection from '@/common/components/FormSection.tsx'

type Props = {
  control: Control<SchoolFormValues>
  watch: UseFormWatch<SchoolFormValues>
  errors: FieldErrors<SchoolFormValues>
}

export default function StandardizedTestsSection(props: Props) {
  const { control, watch, errors } = props

  return (
    <>
      <FormSection>
        <Controller
          name="StandardizedTestsSchema.isDoingStandardizedTests"
          control={control}
          render={({ field }) => (
            <RadioButtonQuestion
              question={
                'Do you administer a nationally normed standardized test or another type of in-year growth testing?'
              }
              options={YesOrNoOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <FormErrorMessage
          message={
            errors.StandardizedTestsSchema?.isDoingStandardizedTests?.message
          }
        />
      </FormSection>
      {watch('StandardizedTestsSchema.isDoingStandardizedTests') === 'Yes' && (
        <FormSection>
          <Controller
            name="StandardizedTestsSchema.standardizedTests"
            control={control}
            render={({ field }) => (
              <CheckboxQuestion
                question={'What standardized test(s) do you administer?'}
                options={STANDARDIZED_TESTS}
                value={field.value}
                onChange={(value: string[]) => {
                  field.onChange(value)
                }}
              />
            )}
          />
          <FormErrorMessage
            message={errors.StandardizedTestsSchema?.standardizedTests?.message}
          />
        </FormSection>
      )}
      {watch('StandardizedTestsSchema.isDoingStandardizedTests') === 'No' && (
        <FormSection>
          <Label htmlFor="howAreStudentsAssessed">
            If no, how do you assess your students?
            <span className="text-red-500">*</span>
          </Label>
          <Controller
            name="StandardizedTestsSchema.howAreStudentsAssessed"
            control={control}
            render={({ field }) => (
              <Input
                onChange={field.onChange}
                value={field.value}
                onBlur={field.onBlur}
                placeholder="Describe your assessment methods"
              />
            )}
          />
          <FormErrorMessage
            message={
              errors.StandardizedTestsSchema?.howAreStudentsAssessed?.message
            }
          />
        </FormSection>
      )}
    </>
  )
}
